import { SessionService } from './SessionService';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

@Injectable()
export class DataService {

  constructor(private url: string, protected http: Http, protected session: SessionService) {
  }

  getAll(username: string) {
    const options = new RequestOptions({ headers: this.session.getHeaders() });
    return this.http.get(this.url + '/all?username=' + username, options).map(response => response.json());
  }

  create(resource) {
    return this.http.post(this.url, JSON.stringify(resource), { withCredentials: true })
        .map(response => response.json());
  }

  update(resource) {
    return this.http.put(this.url + '/' + resource.id, JSON.stringify(resource), { withCredentials: true })
        .map(response => response.json());
  }

  delete(id) {
    return this.http.delete(this.url + '/' + id, { withCredentials: true })
        .map(response => response.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/service/data.service.ts